import { Delete, Edit, Send, Visibility } from "@mui/icons-material";
import { Box, useTheme } from "@mui/material";
import { FC, ReactNode } from "react";
import Button from "./Button";

interface Props {
  id: number;
  handleEdit?: (id: number) => void;
  handleView?: (id: number) => void;
  handleDelete?: (id: number) => void;
  handleInvite?: (id: number) => void;
  handleAppRoutes?: {
    icon: ReactNode;
    function: (id: number) => void;
    enabled: boolean;
  }[];
  justifyContent?: "flex-start" | "center" | "space-between";
}

const TableActions: FC<Props> = (props) => {
  const {
    id,
    handleEdit,
    handleView,
    handleDelete,
    handleInvite,
    handleAppRoutes,
    justifyContent = "center",
  } = props;
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent,
        color: theme.palette.primary.main,
        width: "100%",
      }}
      component={"span"}
    >
      {!!handleAppRoutes ? (
        handleAppRoutes.map((route, index) => {
          return (
            <Button
              key={index}
              onClick={() => route.function(id)}
              color="error"
              icon={route.icon}
              disabled={!route.enabled}
            />
          );
        })
      ) : (
        <>
          {!!handleView && (
            <Button
              tooltip="View"
              onClick={() => handleView(id)}
              color="success"
              icon={<Visibility fontSize={"small"} aria-label="view-button" />}
            />
          )}
          {!!handleEdit && (
            <Button
              tooltip="Edit"
              onClick={() => handleEdit(id)}
              color="primary"
              icon={<Edit fontSize={"small"} aria-label="edit-button" />}
            />
          )}
          {!!handleInvite && (
            <Button
              tooltip="Send Invite"
              onClick={() => handleInvite(id)}
              color="secondary"
              icon={<Send fontSize={"small"} aria-label="invite-button" />}
            />
          )}
          {!!handleDelete && (
            <Button
              tooltip="Delete"
              onClick={() => handleDelete(id)}
              color="error"
              icon={<Delete fontSize={"small"} aria-label="delete-button" />}
            />
          )}
        </>
      )}
    </Box>
  );
};

export default TableActions;
